module.exports = __webpack_public_path__ + "img/title-3.a6350110.png";